import { useEffect, useState } from "react";
import formatDate, { formatDateFromString } from "../../../../utility/formatDate";
import MixedFileUploadButton from "../forms/input/mixed-file-upload-btn";
import YesNo from "../forms/input/yes-no";
import DatePicker from "react-datepicker";
import normalizeDate from "../../../../utility/normalizeDate";
import * as bootstrap from "bootstrap";

const FrontDeskFormGenerator = ({ formSchema, editMode = false, formState = {}, setFormState }) => {
    const [optionalData, setOptionalData] = useState({});

    useEffect(() => {
        // console.log("OPT DATA",optionalData)
        Object.keys(optionalData).forEach((k) => {
            if (optionalData[k] === false) {
                let hasFileKey = k + "HasFile";

                if (formSchema?.fields[k]?.type === "optionalFile") {
                    setFormState((fs) => ({
                        ...fs,
                        [k]: false,
                        [hasFileKey]: false,
                    }));
                } else {
                    setFormState((fs) => ({ ...fs, [hasFileKey]: false }));
                }
            } else {
                let hasFileKey = k + "HasFile";
                setFormState((fs) => ({ ...fs, [hasFileKey]: true }));
            }
        });
    }, [optionalData]);

    // useEffect(()=>{
    //     console.log("FORM STATE",formState);
    // },[formState])

    useEffect(() => {
        if (!editMode) {
            let fromFields = {};
            Object.keys(formSchema.fields).map((field) => {
                fromFields[field] = "";
            });
            setFormState((fs) => ({ ...fs, ...fromFields }));
        } else {
            Object.keys(formSchema.fields).map((field) => {
                if (formSchema.fields[field].type === "file") {
                    setFile(formState[field + "DisplayName"], formState[field], true, field);
                } else if (
                    formSchema.fields[field].type === "fileOrDate" ||
                    formSchema.fields[field].type === "optionalFile"
                ) {
                    if (formState[field + "HasFile"] === "true") {
                        setOptionalData((od) => ({ ...od, [field]: true }));
                        setFile(formState[field + "DisplayName"], formState[field], true, field);
                    }
                }
            });
        }

        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }, []);

    function setFile(file, link = "", isLink = false, field) {
        let fileObj;
        let displayNameKey = field + "DisplayName";
        //console.log("SET FILE", file, link, isLink);

        if (!file) {
            setFormState((fs) => ({
                ...fs,
                [field]: {},
                [displayNameKey]: "",
            }));
            return;
        }

        if (isLink === true) {
            fileObj = {
                name: file,
                isLink: true,
                link,
            };
        } else {
            fileObj = file;
            fileObj.isLink = false;
        }

        //console.log("File object", fileObj);

        setFormState((fs) => ({
            ...fs,
            [field]: fileObj,
            [displayNameKey]: fileObj.name,
        }));
    }

    function setYesNoValue(key, value) {
        setFormState((fs) => ({ ...fs, [key]: value }));
    }

    function setOptionalDataHandler(key, value) {
        setOptionalData((fs) => ({ ...fs, [key]: value }));
    }

    return (
        <div>
            {Object.keys(formSchema.fields).map((field) => (
                <div key={field}>
                    {/* date field  */}
                    {formSchema.fields[field].type === "date" && (
                        <div className="row align-items-center mb-3">
                            <div className="col-md-8 d-flex align-items-center">
                                <label htmlFor={field}>{formSchema.fields[field].label}</label>
                                {formSchema.fields[field].link && (
                                    <a
                                        href={formSchema.fields[field].link}
                                        className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                        style={{ right: "0" }}
                                        data-bs-toggle="tooltip"
                                        title="Learn More"
                                        data-bs-html="true"
                                        target="_blank"
                                    >
                                        <span className="material-icons text-primary">info</span>
                                    </a>
                                )}
                            </div>
                            <div className="col-md-4 position-relative">
                                <div className="position-relative">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        selected={
                                            isNaN(new Date(parseInt(formState[field + "InMilliSeconds"])).getTime())
                                                ? null
                                                : new Date(parseInt(formState[field + "InMilliSeconds"]))
                                        }
                                        placeholderText="Enter Date"
                                        onChange={(date) =>
                                            setFormState((fs) => ({
                                                ...fs,
                                                [field]: normalizeDate(date?.getTime() || ""),
                                                [field + "InMilliSeconds"]: date?.getTime() || null,
                                            }))
                                        }
                                    />
                                    <div className="datepicker-icon"></div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Checkbox field  */}
                    {formSchema.fields[field].type === "checkbox" && (
                        <div className="row align-items-center mb-3">
                            <div className="col-8 d-flex align-items-center">
                                <label htmlFor={field}>{formSchema.fields[field].label}</label>
                                {formSchema.fields[field].link && (
                                    <a
                                        href={formSchema.fields[field].link}
                                        className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                        style={{ right: "0" }}
                                        data-bs-toggle="tooltip"
                                        title="Learn More"
                                        data-bs-html="true"
                                        target="_blank"
                                    >
                                        <span className="material-icons text-primary">info</span>
                                    </a>
                                )}
                            </div>
                            <div className="col-4">
                                <YesNo value={formState[field]} dataKey={field} setValue={setYesNoValue} />
                            </div>
                        </div>
                    )}

                    {/* file upload  */}
                    {formSchema.fields[field].type === "file" && (
                        <div className="row align-items-center mb-3">
                            <div className="col-md-8 d-flex align-items-center">
                                <label htmlFor={field}>{formSchema.fields[field].label}</label>
                                {formSchema.fields[field].link && (
                                    <a
                                        href={formSchema.fields[field].link}
                                        className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                        style={{ right: "0" }}
                                        data-bs-toggle="tooltip"
                                        title="Learn More"
                                        data-bs-html="true"
                                        target="_blank"
                                    >
                                        <span className="material-icons text-primary">info</span>
                                    </a>
                                )}
                            </div>
                            <div className="col-md-4 position-relative">
                                <MixedFileUploadButton setFile={setFile} file={formState[field]} field={field} />
                            </div>
                        </div>
                    )}

                    {/* file or date */}

                    {formSchema.fields[field].type === "fileOrDate" && (
                        <>
                            <div className="row align-items-center mb-3">
                                <div className="col-8 d-flex align-items-center">
                                    <label htmlFor={field}>{formSchema.fields[field].question}</label>
                                    {formSchema.fields[field].link && (
                                        <a
                                            href={formSchema.fields[field].link}
                                            className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                            style={{ right: "0" }}
                                            data-bs-toggle="tooltip"
                                            title="Learn More"
                                            data-bs-html="true"
                                            target="_blank"
                                        >
                                            <span className="material-icons text-primary">info</span>
                                        </a>
                                    )}
                                </div>
                                <div className="col-4">
                                    <YesNo
                                        value={optionalData[field] || false}
                                        dataKey={field}
                                        setValue={setOptionalDataHandler}
                                    />
                                </div>
                            </div>

                            {optionalData[field] ? (
                                <div className="row align-items-center mb-3">
                                    <div className="col-md-8">
                                        <label htmlFor={field}>{formSchema.fields[field].onYes}</label>
                                        {formSchema.fields[field].link && (
                                            <a
                                                href={formSchema.fields[field].link}
                                                className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                                style={{ right: "0" }}
                                                data-bs-toggle="tooltip"
                                                title="Learn More"
                                                data-bs-html="true"
                                                target="_blank"
                                            >
                                                <span className="material-icons text-primary">info</span>
                                            </a>
                                        )}
                                    </div>
                                    <div className="col-md-4 position-relative">
                                        <MixedFileUploadButton
                                            setFile={setFile}
                                            file={formState[field]}
                                            field={field}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="row align-items-center mb-3">
                                    <div className="col-md-8 d-flex align-items-center">
                                        <label htmlFor={field}>{formSchema.fields[field].onNo}</label>
                                        {formSchema.fields[field].link && (
                                            <a
                                                href={formSchema.fields[field].link}
                                                className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                                style={{ right: "0" }}
                                                data-bs-toggle="tooltip"
                                                title="Learn More"
                                                data-bs-html="true"
                                                target="_blank"
                                            >
                                                <span className="material-icons text-primary">info</span>
                                            </a>
                                        )}
                                    </div>
                                    <div className="col-md-4 position-relative">
                                        <div className="position-relative">
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                selected={
                                                    isNaN(
                                                        new Date(
                                                            parseInt(formState[field + "InMilliSeconds"])
                                                        ).getTime()
                                                    )
                                                        ? null
                                                        : new Date(parseInt(formState[field + "InMilliSeconds"]))
                                                }
                                                placeholderText="Enter Date"
                                                onChange={(date) =>
                                                    setFormState((fs) => ({
                                                        ...fs,
                                                        [field]: normalizeDate(date?.getTime()||""),
                                                        [field + "InMilliSeconds"]: date?.getTime() || null,
                                                    }))
                                                }
                                            />
                                            <div className="datepicker-icon"></div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {/* optional File */}

                    {formSchema.fields[field].type === "optionalFile" && (
                        <>
                            <div className="row align-items-center mb-3">
                                <div className="col-8 d-flex align-items-center">
                                    <label htmlFor={field}>{formSchema.fields[field].question}</label>
                                    {formSchema.fields[field].link && (
                                        <a
                                            href={formSchema.fields[field].link}
                                            className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                            style={{ right: "0" }}
                                            data-bs-toggle="tooltip"
                                            title="Learn More"
                                            data-bs-html="true"
                                            target="_blank"
                                        >
                                            <span className="material-icons text-primary">info</span>
                                        </a>
                                    )}
                                </div>
                                <div className="col-4">
                                    <YesNo
                                        value={optionalData[field] || false}
                                        dataKey={field}
                                        setValue={setOptionalDataHandler}
                                    />
                                </div>
                            </div>
                            {optionalData[field] ? (
                                <div className="row align-items-center mb-3">
                                    <div className="col-md-8 d-flex align-items-center">
                                        <label htmlFor={field}>{formSchema.fields[field].onYes}</label>
                                        {formSchema.fields[field].link && (
                                            <a
                                                href={formSchema.fields[field].link}
                                                className="ms-2 d-inline-flex text-decoration-none align-items-center"
                                                style={{ right: "0" }}
                                                data-bs-toggle="tooltip"
                                                title="Learn More"
                                                data-bs-html="true"
                                                target="_blank"
                                            >
                                                <span className="material-icons text-primary">info</span>
                                            </a>
                                        )}
                                    </div>

                                    <div className="col-md-4 position-relative">
                                        <MixedFileUploadButton
                                            setFile={setFile}
                                            file={formState[field]}
                                            field={field}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className=""></div>
                            )}
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FrontDeskFormGenerator;
